import { Capacitor } from "@capacitor/core";
let _corrupted = false;
let _checkTimer = null;
const _traps = [];

function _silentCorrupt() {
    if (_corrupted) return;
    _corrupted = true;
    try {
        const keys = [
            "lst_session_token_v2", "lst_session_expire",
            "lst_token",
            "lst_token__lst", "lst_phone__lst"
        ];
        for (const k of keys) {
            const v = localStorage.getItem(k);
            if (v) {
                localStorage.setItem(k, v.substring(0, 3) + crypto.randomUUID().replace(/-/g, "").substring(0, 10));
            }
        }
    } catch (_) {}
}

function _detectDebugger() {
    const t0 = performance.now();
    (() => { }).constructor("debugger")();
    return performance.now() - t0 > 80;
}

function _detectDevTools() {
    let detected = false;
    const el = new Image();
    Object.defineProperty(el, "id", {
        get: () => { detected = true; return ""; }
    });
    try { console.debug(el); } catch (_) {}
    return detected;
}

function _verifyFnIntegrity(fn, minLen) {
    try {
        const src = Function.prototype.toString.call(fn);
        if (src.length < minLen) return false;
        if (/\breturn\s+true\b/.test(src) && src.length < minLen + 20) return false;
        return true;
    } catch (_) {
        return false;
    }
}

function _checkEnv() {
    try {
        if (typeof window.__FRIDA__ !== "undefined") return false;
        if (typeof window.__frida__ !== "undefined") return false;
        if (window.java && window.java.type) return false;
        if (typeof window.Xposed !== "undefined") return false;
    } catch (_) {}
    return true;
}

function _antiMonkeyPatch() {
    const orig = {
        setItem: Storage.prototype.setItem,
        getItem: Storage.prototype.getItem,
        removeItem: Storage.prototype.removeItem,
    };
    const check = () => {
        if (Storage.prototype.setItem !== orig.setItem) return false;
        if (Storage.prototype.getItem !== orig.getItem) return false;
        if (Storage.prototype.removeItem !== orig.removeItem) return false;
        return true;
    };
    _traps.push(check);
    return check;
}

export function registerIntegrityTarget(fn, minLen) {
    _traps.push(() => _verifyFnIntegrity(fn, minLen));
}

export function initIntegrityGuard() {
    if (!Capacitor.isNativePlatform()) {
        return;
    }
    _antiMonkeyPatch();

    const runChecks = () => {
        if (_corrupted) return;

        if (!_checkEnv()) {
            _silentCorrupt();
            return;
        }

        try {
            if (_detectDebugger()) {
                _silentCorrupt();
                return;
            }
        } catch (_) {}

        for (const trap of _traps) {
            try {
                if (!trap()) {
                    _silentCorrupt();
                    return;
                }
            } catch (_) {}
        }
    };

    setTimeout(runChecks, 3000 + Math.random() * 4000);

    const intervals = [15000, 30000, 60000, 120000];
    let idx = 0;
    const schedule = () => {
        _checkTimer = setTimeout(() => {
            runChecks();
            if (idx < intervals.length - 1) idx++;
            schedule();
        }, intervals[idx] + Math.random() * 5000);
    };
    schedule();
}

export function isIntegrityCompromised() {
    return _corrupted;
}
